var map = {
	"./ALV-big-logo.png": 3206,
	"./M10-big-logo.png": 9149,
	"./S10-small-logo.png": 4529,
	"./UNI-big-logo-light.png": 272,
	"./UNI-big-logo.png": 480,
	"./UNI-small-logo.png": 3492
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8282;